import { Card, CardBody } from "reactstrap"

/**
 * Minimal, theme-aware statistic card: a labelled value with an optional
 * trend badge, supporting subtitle and a circular accent icon.
 *
 * Shared across dashboards and list summaries so headline numbers render
 * consistently.
 *
 * @param {object} props
 * @param {string} props.title    - Stat label.
 * @param {*}      props.value    - Headline value (already formatted).
 * @param {string} props.subtitle - Optional supporting text.
 * @param {string} props.icon     - Boxicons class (e.g. "bx-gas-pump").
 * @param {object} props.trend    - Optional `{ value, color, tooltip }` badge.
 * @param {string} props.color    - Bootstrap theme color for the accent.
 */
const StatCard = ({ title, value, subtitle, icon, trend, color = "primary" }) => (
  <Card className="border-0 rounded-3 shadow-sm hover-lift transition-all mb-0 h-100">
    <CardBody className="p-3">
      <div className="d-flex align-items-center justify-content-between">
        <div className="flex-grow-1">
          <div className="text-muted small fw-medium mb-1">{title}</div>
          <div className="d-flex align-items-baseline gap-2">
            <h4 className="mb-0 fw-bold">{value}</h4>
            {trend && (
              <span
                className={`badge bg-${trend.color}-subtle text-${trend.color} small`}
                title={trend.tooltip}
              >
                {trend.value}
              </span>
            )}
          </div>
          {subtitle && <div className="text-muted small mt-1">{subtitle}</div>}
        </div>
        {icon && (
          <div
            style={{ width: "2rem", height: "2rem" }}
            className={`d-flex align-items-center justify-content-center rounded-circle p-2 bg-${color}-subtle`}
          >
            <i className={`bx ${icon} text-${color} fs-5`} />
          </div>
        )}
      </div>
    </CardBody>
  </Card>
)

export default StatCard
